import { createContext, useContext } from 'react';
import type { ValidationResult } from '../model/validation';

const EMPTY: ValidationResult = { issues: [], badNodeIds: new Set(), badEdgeIds: new Set() };

export const ValidationContext = createContext<ValidationResult>(EMPTY);

export const useValidation = (): ValidationResult => useContext(ValidationContext);
